import { render } from "./BlockImg.vue?vue&type=template&id=2659893b"
import script from "./BlockImg.vue?vue&type=script&lang=js"
export * from "./BlockImg.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/BlockEditors/BlockImg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2659893b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2659893b', __exports__)) {
    console.log('reload')
    api.reload('2659893b', __exports__)
  }
  
  module.hot.accept("./BlockImg.vue?vue&type=template&id=2659893b", () => {
    console.log('re-render')
    api.rerender('2659893b', render)
  })

}


export default __exports__